import React, { Suspense, useState, useEffect, useRef } from 'react';
import {
  Box,
  Layout,
  SideBarToogle,
  Text,
  Grid,
  Accordion,
  Button,
  DropDown,
} from '@flexisaf/flexibull2';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, NavLink, useRouteMatch, useHistory } from 'react-router-dom';
import IdleTimer from 'react-idle-timer';
import IdleModal from './IdleModal';
import {
  imgCacheClearerSelector,
  selectInstitution,
  selectPortalSlug,
  selectCanonicalOrgId,
  selectOrgAliases,
  selectIsSet,
} from 'redux/configurations/selectors';
import { getAuthOrganisationId } from 'utils/portalSlug';
import { ConfigMenu } from 'components/styles/configurations.style';
import {
  getPortal,
  getInstitution,
  fetchOrgBranches,
} from 'redux/configurations/actions';
import { selectAllConfigs } from 'redux/payment-configuration/selectors';
import { fetchPaymentConfig } from 'redux/payment-configuration/actions';
import { startFetchOrgAddons } from 'redux/addons/actions';
import Routes from 'routes';
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  getLocalUser,
  logout,
  setLocalRefreshToken,
  getLocalUserNameAbbreviation,
  getLocalUserAdminDetails,
  getOrgName,
} from 'utils/helpers';
import Theme from 'utils/theme';
import { selectPrivileges } from 'redux/ums-user-management/selectors';
import { startFetchprivileges } from 'redux/ums-user-management/actions';
import { selectRefreshToken } from 'redux/users/selectors';
import { fetchLevelItems, fetchLevels } from 'redux/adminlevels/actions';
import { selectOrganisation } from 'redux/base/selectors';
import { setTourRun, setTourStepIndex } from 'redux/tours/actions';
import { selectTiedApplications } from 'redux/forms/selectors';
import { selectDownloadIds } from 'redux/direct-download/selector';
import { startFetchTiedApplications } from 'redux/forms/actions';
import { getAllCourses } from 'redux/courses/actions';
import CanView, {
  canViewAdminlevel,
  canViewSystemSettings,
  canViewReminder,
  canViewAdminlevelItem,
  canViewApplicationGroup,
  canViewApplicationGroupItem,
  canViewTemplates,
  canViewPaylog,
  canViewCoupons,
  canViewTransactions,
  canHandleReport,
  canHandleEmail,
  canViewStatistics,
  canViewApplications,
  canViewCourses,
  canViewForms,
  canViewCandidates,
  canViewCandidateGroups,
  canViewUsers,
  canViewWorkflow,
} from 'components/CanView';
import { Notifications } from './Notifications';
import {
  fetchNotifications,
  getNewNotifications,
  openNewNotification,
} from 'redux/notifications/actions';
import ReconnectingWebSocket from 'reconnecting-websocket';
import urls from 'utils/config';
import { selectNewNotifications } from 'redux/notifications/selectors';
import {
  selectAdminLevel,
  selectAdminLevelItems,
} from 'redux/adminlevels/selectors';
import { queryDownloadIds } from 'redux/direct-download/actions';
import GlobalExportMonitor from 'components/applicants/ApplicantModals/DynamicExport/GlobalExportMonitor';
import styled from 'styled-components';
import { HIERARCHICAL_GROUP_SHORT } from 'utils/constants';
import {
  startFetchDocumentUserTemplate,
  startFetchEmailUserTemplate,
} from 'redux/template/actions';
import { selectAccounts } from 'redux/international-payment-configuration/selectors';
import { getBankAccount } from 'redux/international-payment-configuration/actions';
import { selectTourIndex, selectTourRun } from 'redux/tours/selector';
const MenuContentStyling = styled.div`
  & .flexi-accordion-body {
    border: none;
    padding: 0px 15px;
    ul {
      list-style: none;
      margin: -5px 0 0 0;
      padding: 10px 0 0 60px;
      color: '#575757';
      display: flex;
      flex-direction: column;
      a {
        padding-bottom: 24px;
        color: '#575757';
        i {
          margin-right: 10px;
        }
      }
    }
  }
  & .nav-item {
    padding: 15px;
    margin: 0;
    margin-left: 18px;
    font-size: 1.1em;
    & .nav-item-text {
      margin-left: 30px;
      text-transform: capitalize;
    }
  }
`;

const LayoutWrapper = styled.div`
  & .flexi-layout {
    & > div:first-child {
      overflow: visible;
    }
  }
`;

const TopNavWrapper = styled.div`
  margin-right: 30px;
  display: flex;
  align-items: center;
  gap: 20px;
  @media (max-width: 580px) {
    display: flex;
    justify-content: space-around;
  }
`;

const Gotoapplicantnav = styled.div`
  @media (min-width: 600px) {
    display: none;
  }
`;
const Gotoapplicant = styled.div`
  @media (max-width: 600px) {
    display: none;
  }
`;

const TopNav = styled.div`
  margin-right: 30px;
  display: flex;
  align-items: center;
  gap: 20px;
  @media (max-width: 580px) {
    display: flex;
    flex-direction: column;
  }
`;

const Group = styled.div`
  & .group-title {
    padding: 20px 25px 20px 15px;
    margin-bottom: 10px;
    border-bottom: 1px dashed ${Theme.PrimaryGrey};
  }

  & i {
    font-size: 16px;
  }
`;

const { API_BASE_URL, WEB_SOCKET, APPLICANT_URL } = urls || {};

const MainApp = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { params } = useRouteMatch();
  const portalSlug = useSelector(selectPortalSlug);
  const canonicalOrgId = useSelector(selectCanonicalOrgId);
  const orgSlug = canonicalOrgId && portalSlug ? portalSlug : params.orgName;
  const aliases = useSelector(selectOrgAliases);
  const privileges = useSelector(selectPrivileges);
  const refreshToken = useSelector(selectRefreshToken);
  const organisation = useSelector(selectInstitution);
  const paymentConfigs = useSelector(selectAllConfigs);
  const intAccounts = useSelector(selectAccounts);
  const tiedApplications = useSelector(selectTiedApplications);
  const notificationCount = useSelector(selectNewNotifications);
  const downloadIds = useSelector(selectDownloadIds);
  const stepIndex = useSelector(selectTourIndex);
  const tourRun = useSelector(selectTourRun);
  const [menuDrawer, setMenuDrawer] = useState(false);
  const [idleModal, setIdleModal] = useState(false);
  const base = useSelector(selectOrganisation);
  const [user, setUser] = useState(null);
  const adminLevels = useSelector(selectAdminLevel);
  const isSet = useSelector(selectIsSet);
  const adminLevelItems = useSelector(selectAdminLevelItems);
  const imgCacheClearer = useSelector(imgCacheClearerSelector);
  const [adminDetails, setAdminDetails] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!user || !adminLevels || !adminLevelItems) return;
    const adminDetails = getLocalUserAdminDetails(
      user?.adminRoles[0]?.adminLevel,
      adminLevelItems,
      adminLevels
    );
    setAdminDetails(adminDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, adminLevels, adminLevelItems]);

  useEffect(() => {
    const authOrgId = getAuthOrganisationId();
    const canonical = canonicalOrgId || '';
    if (authOrgId && canonical && authOrgId !== canonical) {
      return;
    }
    if (!isSet) {
      const orgIdForInstitution = authOrgId || canonical || base.organisation;
      dispatch(fetchLevels());
      dispatch(fetchLevelItems());
      dispatch(getPortal());
      dispatch(getInstitution(orgIdForInstitution));
      dispatch(getAllCourses());
      dispatch(fetchNotifications());
      dispatch(getNewNotifications());
      dispatch(fetchOrgBranches({ page: 0, size: 5 }));
      dispatch(startFetchEmailUserTemplate({ currentPage: 0, pageSize: 10 }));
      dispatch(
        startFetchDocumentUserTemplate({ currentPage: 0, pageSize: 10 })
      );
    }

    if (!tiedApplications) {
      dispatch(startFetchTiedApplications());
    }
    dispatch(startFetchOrgAddons());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const user = JSON.parse(getLocalUser());
    const token = getLocalAccessToken();
    if (user.id && token) {
      setUser(user);
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'user_session',
          orgId: canonicalOrgId || params.orgName,
          userId: user.id,
        });
      }

      const options = {
        connectionTimeout: 1000,
        maxRetries: 10,
      };

      const userId = user.id;
      const socket = new ReconnectingWebSocket(
        `${WEB_SOCKET}://${token}@${
          API_BASE_URL.split('//')[1]
        }/notifications/${userId}`,
        [],
        options
      );
      socket.onopen = function () {
        console.log('Connected to the web socket');
      };

      socket.onclose = function () {
        console.log('Disconnected from the web socket');
      };

      socket.onmessage = function () {
        dispatch(fetchNotifications());
        dispatch(getNewNotifications());
      };
      //clean up function
      return () => socket.close();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!paymentConfigs) {
      dispatch(fetchPaymentConfig());
    }
    if (!intAccounts) {
      dispatch(getBankAccount());
    }
    if (!privileges.length) {
      dispatch(startFetchprivileges());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentConfigs]);

  useEffect(() => {
    const storedRefreshToken = getLocalRefreshToken();
    if (refreshToken && refreshToken !== storedRefreshToken) {
      setLocalRefreshToken(refreshToken);
    }
  }, [refreshToken]);

  useEffect(() => {
    if (idleModal) {
      const sessionTimeOut = setTimeout(() => logout(), 1000 * 60 * 3);
      return () => {
        clearTimeout(sessionTimeOut);
      };
    }
  }, [idleModal]);

  useEffect(() => {
    const queryDownload = setInterval(() => {
      const filteredDownloadIds = downloadIds.filter(
        (ids) => ids?.org === getOrgName()
      );
      if (downloadIds.length > 0 && filteredDownloadIds.length > 0) {
        dispatch(queryDownloadIds(filteredDownloadIds, downloadIds));
      }
    }, 3000);
    return () => clearInterval(queryDownload);
  }, [downloadIds, dispatch]);

  useEffect(() => {
    if (tourRun) {
      if (stepIndex === 1) {
        setMenuDrawer(false);
      }
    }
  }, [tourRun, stepIndex]);

  useEffect(() => {
    if (!localStorage.getItem('tourFirstRun')) {
      dispatch(setTourRun(true));
      setTimeout(() => {
        localStorage.setItem('tourFirstRun', true);
      }, 10000);
    }
  }, [dispatch]);

  const handleOnIdle = () => {
    setIdleModal(true);
  };

  const resume = () => {
    setIdleModal(false);
  };

  const [notify, setNotify] = useState(false);

  const goToApplicantPortal = () => {
    const slug = portalSlug || params.orgName;
    window.open(`${APPLICANT_URL}/${slug}`, '_blank');
  };

  const openSettings = () => {
    setMenuDrawer(!menuDrawer);
    if (tourRun) {
      if (stepIndex === 1) {
        dispatch(setTourRun(false));
        dispatch(setTourStepIndex(2));

        setTimeout(() => {
          dispatch(setTourRun(true));
        }, 800);
      }
    }
  };

  return (
    <LayoutWrapper>
      <Layout
        theme={Theme}
        withSideNav
        withTopNav
        sideNavOpenWidth={Theme.SideNavOpen}
        sideNavCloseWidth={Theme.SideNavClose}
        collapseIcon="flexibull-cancel-1"
        expandIcon="flexibull-menu-1"
        topNavContent={
          <TopNavWrapper>
            <Gotoapplicant>
              <Button onClick={() => goToApplicantPortal()} spaceRight pale>
                Go to Applicant Site
              </Button>
            </Gotoapplicant>
            <Gotoapplicant>
              <Button
                onClick={() => {
                  dispatch(setTourRun(true));
                }}
                spaceRight
                pale
              >
                Tour Guide
              </Button>
            </Gotoapplicant>

            <DropDown
              trigger="click"
              menuAlign="bottom right"
              width="200px"
              style={{ cursor: 'pointer' }}
              label={
                <div
                  style={{
                    borderRadius: '100px',
                    width: '35px',
                    height: '35px',
                    backgroundColor: '#E6DFFE',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Text size="10px" bold color={Theme.PrimaryColor}>
                    {getLocalUserNameAbbreviation(user)}
                  </Text>
                </div>
              }
            >
              <Box style={{ borderBottom: '0.5px solid #E0DEDE' }}>
                <div
                  style={{
                    width: '100%',
                    height: '50px',
                    backgroundColor: 'rgb(245, 245, 247)',
                    borderRadius: '3px',
                  }}
                  id="systemSettings"
                />
                <div
                  style={{
                    borderRadius: '100px',
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#E6DFFE',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '-25px',
                  }}
                  onClick={() => history.push(`/${orgSlug}/user-profile`)}
                >
                  <Text size="10px" bold color={Theme.PrimaryColor}>
                    {getLocalUserNameAbbreviation(user)}
                  </Text>
                </div>
                <Text
                  size="12px"
                  color={Theme.PrimaryDark}
                  block
                  style={{
                    textAlign: 'center',
                    marginBottom: '10px',
                    marginTop: '10px',
                  }}
                >
                  {user?.firstName} {user?.lastName}
                </Text>
                <div>
                  <Text
                    color={Theme.PrimaryDark}
                    size="10px"
                    style={{ textAlign: 'center' }}
                    block
                  >
                    {adminDetails?.adminLevel?.name}
                  </Text>
                  <Text
                    color={Theme.PrimaryDark}
                    size="10px"
                    block
                    style={{ textAlign: 'center' }}
                  >
                    {adminDetails?.adminLevelItem?.name}
                  </Text>
                </div>
                <div
                  style={{
                    padding: '5px',
                    borderRadius: '3px',
                    backgroundColor: '#E7E6EC',
                    marginRight: 'auto',
                    marginLeft: 'auto',
                    width: 'fit-content',
                    border: '0.5px dashed #A3A3A4',
                    marginTop: '10px',
                  }}
                >
                  <Text size="10px" style={{ textAlign: 'center' }}>
                    {user?.adminRoles[0]?.roles?.name}
                  </Text>
                </div>
              </Box>

              <Text
                onClick={() => history.push(`/${orgSlug}/user-profile`)}
                block
                style={{ textAlign: 'center' }}
              >
                My Profile
              </Text>

              <Text
                block
                style={{ textAlign: 'center' }}
                onClick={() => logout()}
              >
                Logout
              </Text>
            </DropDown>
            <Box
              style={{ position: 'relative', cursor: 'pointer' }}
              display="inline-block"
            >
              <Text
                onClick={() => {
                  setNotify(true);
                  dispatch(openNewNotification());
                }}
                size="18px"
              >
                <i className="saf-bell" />
                {notificationCount > 0 && (
                  <Box
                    background="red"
                    vAlign
                    pad="4px"
                    style={{
                      borderRadius: '20px',
                      position: 'absolute',
                      top: '0px',
                      left: '20px',
                      fontSize: '10px',
                    }}
                  >
                    <Text color="white" bold>
                      {notificationCount > 99 ? '99+' : notificationCount}
                    </Text>
                  </Box>
                )}
              </Text>
            </Box>
            <Box
              display="inline-block"
              onClick={() => openSettings()}
              id="systemSettings"
            >
              <Text
                size="18px"
                bold={menuDrawer}
                color={menuDrawer ? Theme.PrimaryColor : 'inherit'}
              >
                <i className="saf-cog-2" />
              </Text>
            </Box>
          </TopNavWrapper>
        }
        sideNavProps={{
          float: false,
          background: '#ffffff',
          brand: (
            <SideBarToogle>
              <Grid
                default="200px 250px"
                templateRow="60px"
                alignItems="center"
                style={{ maxHeight: '4rem' }}
              >
                {organisation.logoUrl ? (
                  <img
                    src={`${organisation.logoUrl}?b=${imgCacheClearer}`}
                    alt="SAFApply"
                    style={{
                      marginLeft: '10px',
                      objectFit: 'contain',
                      height: '100%',
                      objectPosition: 'left',
                    }}
                  />
                ) : (
                  <h1 style={{ margin: '15px' }}>{organisation?.id}</h1>
                )}
              </Grid>
            </SideBarToogle>
          ),
          // menuList: CanFilter(menuItems(params.orgName, aliases)),
        }}
        sideNavContent={
          <>
            <CanView can={canViewStatistics}>
              <MenuContentStyling id="dashboard">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/dashboard`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-gauge" />
                    <span className="nav-item-text">Dashboard</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewApplications}>
              <MenuContentStyling id="applications">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/applications`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-vcard" />
                    <span className="nav-item-text">Applications</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewCourses}>
              <MenuContentStyling id="course">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/courses`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-flow-tree" />
                    <span className="nav-item-text">
                      {aliases?.course || 'Course'}
                    </span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewForms}>
              <MenuContentStyling id="forms">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/forms`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-wpforms" />
                    <span className="nav-item-text">Forms</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewCandidates}>
              <MenuContentStyling id="process-applicants">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/applicants`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-user" />
                    <span className="nav-item-text">Process Applicants</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewCandidateGroups}>
              <MenuContentStyling id="uploaded-candidates">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/uploaded-candidates`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-address-card-o" />
                    <span className="nav-item-text">Uploaded Candidates</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewTransactions}>
              <MenuContentStyling id="transactions">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/transactions`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-history" />
                    <span className="nav-item-text">Transactions</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewUsers}>
              <MenuContentStyling id="users">
                <ul className="nav-item">
                  <NavLink
                    to={`/${orgSlug}/users`}
                    activeStyle={{
                      fontWeight: 'bold',
                      color: Theme.PrimaryColor,
                    }}
                    style={{
                      fontWeight: 'normal',
                      fontStyle: 'normal',
                      color: '#575757',
                    }}
                  >
                    <i className="saf-users-outline" />
                    <span className="nav-item-text">Users</span>
                  </NavLink>
                </ul>
              </MenuContentStyling>
            </CanView>
            <CanView can={canViewTransactions}>
              <MenuContentStyling id="users">
                <Accordion
                  style={{
                    border: 'none',
                    fontSize: '13.2px',
                    boxShadow: 'none',
                  }}
                  gap="10px"
                  elevate="low"
                >
                  <div
                    label={
                      <span style={{ paddingLeft: '16px' }}>
                        <i className="saf-info" />
                        <span
                          style={{
                            paddingLeft: '32px',
                            fontWeight: 'normal',
                          }}
                        >
                          Audit Log
                        </span>
                      </span>
                    }
                  >
                    <ul>
                      <NavLink
                        to={`/${orgSlug}/audit-log`}
                        activeStyle={{
                          fontWeight: 'bold',
                          color: Theme.PrimaryColor,
                        }}
                        style={{
                          fontWeight: 'normal',
                          fontStyle: 'normal',
                          color: '#575757',
                        }}
                      >
                        <i className="saf-info" />
                        <span>Activity Log</span>
                      </NavLink>
                      <NavLink
                        to={`/${orgSlug}/modification-log`}
                        activeStyle={{
                          fontWeight: 'bold',
                          color: Theme.PrimaryColor,
                        }}
                        style={{
                          fontWeight: 'normal',
                          fontStyle: 'normal',
                          color: '#575757',
                        }}
                      >
                        <i className="saf-info" />
                        Modification Log
                      </NavLink>
                    </ul>
                  </div>
                </Accordion>
                <TopNav>
                  <Gotoapplicantnav>
                    <Button
                      onClick={() => goToApplicantPortal()}
                      spaceRight
                      pale
                    >
                      Go to Applicant Site
                    </Button>
                  </Gotoapplicantnav>
                </TopNav>
              </MenuContentStyling>
            </CanView>
          </>
        }
      >
        <IdleTimer
          ref={timerRef}
          timeout={1000 * 60 * 10}
          onIdle={handleOnIdle}
        />
        <ConfigMenu show={menuDrawer} clickHide={() => setMenuDrawer(false)}>
          <Group>
            <Box className="group-title">
              <Text block bold>
                General Configurations
              </Text>
            </Box>
            <ul>
              <CanView can={canViewSystemSettings}>
                <li id="system-settings_menu">
                  <NavLink to={`/${orgSlug}/configurations`}>
                    <i className="saf-equalizer" /> System Settings
                  </NavLink>
                </li>
              </CanView>
              <CanView can={[...canViewAdminlevel, ...canViewAdminlevelItem]}>
                <li onClick={() => setMenuDrawer(false)} id="org-structure">
                  <NavLink to={`/${orgSlug}/admin-levels-item`}>
                    <i className="saf-flow-split" /> {HIERARCHICAL_GROUP_SHORT}
                  </NavLink>
                </li>
              </CanView>
              <CanView
                can={[
                  ...canViewApplicationGroup,
                  ...canViewApplicationGroupItem,
                ]}
              >
                <li onClick={() => setMenuDrawer(false)} id="application-group">
                  <NavLink to={`/${orgSlug}/application-groupings`}>
                    <i className="saf-group" /> Application Group
                  </NavLink>
                </li>
              </CanView>
              <CanView can={canViewTemplates}>
                <li id="templates">
                  <NavLink to={`/${orgSlug}/templates`}>
                    <i className="saf-doc-text" />
                    Templates
                  </NavLink>
                </li>
              </CanView>
              <CanView can={canViewCoupons}>
                <li>
                  <NavLink to={`/${orgSlug}/discount-code`}>
                    <i className="saf-ticket" />
                    Discount Code
                  </NavLink>
                </li>
              </CanView>
              <CanView can={canViewSystemSettings}>
                <li>
                  <NavLink to={`/${orgSlug}/add-on`}>
                    <i className="saf-doc-text" />
                    Add Ons
                  </NavLink>
                </li>
              </CanView>
              <CanView
                can={[
                  ...canViewReminder,
                  ...canHandleReport,
                  ...canHandleEmail,
                ]}
              >
                <li>
                  <NavLink to={`/${orgSlug}/notifications`}>
                    <i className="saf-bell" />
                    Notifications
                  </NavLink>
                </li>
              </CanView>
              <CanView can={[...canViewWorkflow, ...canViewTemplates]}>
                <li>
                  <NavLink to={`/${orgSlug}/workflow`}>
                    <i className="saf-tasks" /> WorkFlow Process
                  </NavLink>
                </li>
              </CanView>
            </ul>
          </Group>
          <CanView can={canViewPaylog}>
            <Group>
              <Box className="group-title">
                <Text block bold>
                  Payment Settings
                </Text>
              </Box>
              <ul>
                <li>
                  <NavLink to={`/${orgSlug}/local-payments`}>
                    <i className="saf-credit-card" /> Local Payments
                  </NavLink>
                </li>
                <li>
                  <NavLink to={`/${orgSlug}/international-payments`}>
                    <i className="saf-international-payment" /> International
                    Payments
                  </NavLink>
                </li>
              </ul>
            </Group>
          </CanView>
        </ConfigMenu>
        <Switch>
          <Box pad="100px 30px 40px 67px">
            <Suspense fallback={() => <div>Loading...</div>}>
              <Routes />
            </Suspense>
          </Box>
        </Switch>
        <Notifications open={notify} close={() => setNotify(false)} />
        <IdleModal open={idleModal} resume={resume} logout={() => logout()} />
        <GlobalExportMonitor />
      </Layout>
    </LayoutWrapper>
  );
};

export default MainApp;
